import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import qrcode from '../img/qrcodegc.jpg';
import logo from '../img/logo-white.png';
import { FaPlay, FaPause, FaYoutube } from 'react-icons/fa';

const GiftSalesPage = () => {
  const { id } = useParams();
  const promo_end = "2024-02-25";
  const targetDate = new Date(promo_end).getTime();

  // Calculate the remaining time with UTC+8 offset
  const calculateTimeLeft = () => {
    const now = new Date().getTime() + 8 * 60 * 60 * 1000; // UTC+8 offset
    const difference = targetDate - now;

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => {
      clearInterval(countdownInterval);
    };
  }, []);

  const phoneNumber = '60198416042'; // Replace with the actual WhatsApp number

  const message = encodeURIComponent(`Hide Butang Hadiah di Kad Kahwin Digital\nID: ${id}`);
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div>
      <header className="w-full bg-secondary-500 shadow-md py-4 z-10">
        <div className="flex items-center justify-center px-6">
          <a href="/"><img src={logo} alt="Logo" className='h-10' /></a>
        </div>
      </header>
      <div className="md:p-24 flex items-center justify-center">
        <div className="bg-white px-8 py-12 rounded-md md:shadow-lg max-w-md w-full text-center">
          <h1 className="text-2xl font-bold mb-4">Hide Butang Hadiah</h1>
          <p className="text-gray-700 mb-4">
            Sekarang butang hadiah dah boleh di "Hide".
          </p>
          <h2 className='text-xl font-bold my-8'>Boleh lihat demo Kad Kahwin Digital tanpa butang hadiah:</h2>

          <a
            href="https://theinviteyou.com/kad/demoplus"
            target="_blank"
            rel="noreferrer"
            className='block text-center w-full rounded-lg mb-4 text-secondary-500 hover:text-neutral-50 font-bold capitalize px-5 py-3 border border-secondary-500 hover:border-secondary-700 hover:bg-secondary-700'
          >
            Demo
          </a>

          <h2 className='text-xl font-bold my-8'>Nak hide kan butang hadiah?</h2>
          <p className="text-gray-700">Boleh scan QR Code dibawah untuk membuat pembayaran mengikut jumlah berikut:</p>
          <div className='my-8'>
            {/* <h1 className='text-lg line-through'>RM10.00</h1> */}
            <h1 className='text-5xl font-bold'>RM10.00</h1>
            <p className="text-gray-700">sahaja</p>
          </div>
          {/* <p className="text-gray-700">Offer akan tamat dalam masa:</p>
          <div className={`flex justify-center md:space-x-4 space-x-2 my-4`}>
            <div className='bg-red-200 p-4 rounded-lg'>
              <div className="text-3xl md:text-5xl font-bold">{timeLeft.days}</div>
              <div className="text-xl">Hari</div>
            </div>
            <div className='bg-red-300 p-4 rounded-lg'>
              <div className="text-3xl md:text-5xl font-bold">{timeLeft.hours}</div>
              <div className="text-xl">Jam</div>
            </div>
            <div className='bg-secondary-500 p-4 rounded-lg'>
              <div className="text-3xl md:text-5xl font-bold">{timeLeft.minutes}</div>
              <div className="text-xl">Minit</div>
            </div>
            <div className='bg-secondary-700 p-4 rounded-lg'>
              <div className="text-3xl md:text-5xl font-bold">{timeLeft.seconds}</div>
              <div className="text-xl">Saat</div>
            </div>
          </div> */}
          <img src={qrcode} />
          <div className='space-y-8 my-8'>
            <p className="text-gray-700">Selepas membuat pembayaran, boleh hantarkan bukti pembayaran ke WhatsApp kami. Klik butang dibawah:</p>
            <div>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="bg-white text-center text-secondary-500 hover:bg-secondary-500 hover:text-neutral-50 px-5 py-3 rounded w-full border-solid border-2 border-secondary-500"
              >
                Hantar Bukti Pembayaran
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default GiftSalesPage;
